export const EQUIPMENT_HEIGHT = [
  { value: '0', label: `Standard` },
  { value: '5', label: `High Cube` },
]
export const EQUIPMENT_HEIGHT_SHORTNAME = [
  { value: '0', label: `SD` },
  { value: '5', label: `HC` },
]

export const EQUIPMENT_LENGTH = [
  { value: '2', label: `20 ft.` },
  { value: '4', label: `40 ft.` },
  { value: 'L', label: `45 ft.` },
]

export function getContainerType(isReefer) {
  if (isReefer) return 'Reefer'

  return 'Dry'
}

export function getEquipmentLength(value, options = {}) {
  let label = ''

  for (const element of EQUIPMENT_LENGTH) {
    if (element.value === value) {
      label = element.label
    }
  }

  if (options.short) {
    return label.slice(0, 2)
  }

  return label
}

export function getEquipmentHeight(value, options = {}) {
  let label = '-'
  const reference = !options.short ? EQUIPMENT_HEIGHT : EQUIPMENT_HEIGHT_SHORTNAME

  for (const element of reference) {
    if (element.value === value) {
      label = element.label
    }
  }

  return label
}

export const DEFAULT_CONTAINER_TYPES = {
  STANDARD_DRY_BOX: 'G0',
  STANDARD_REEFER: 'R0',
}

export const CONTAINER_TYPES = [
  {
    value: DEFAULT_CONTAINER_TYPES.STANDARD_DRY_BOX,
    label: 'Dry Box',
    labelShort: 'Dry',
  },
  {
    value: 'V0',
    label: 'Ventilated',
  },
  {
    value: 'B0',
    label: 'Bulk goods',
  },
  {
    value: 'S0',
    label: 'Livestock Carrier',
  },
  {
    value: 'S1',
    label: 'Automotive Carrier',
  },
  {
    value: DEFAULT_CONTAINER_TYPES.STANDARD_REEFER,
    label: 'Reefer',
    labelShort: 'Reefer',
  },
  {
    value: 'U0',
    label: 'Open Top',
  },
  {
    value: 'P0',
    label: 'Platform Container with Incomplete Superstructure',
  },
  {
    value: 'P5',
    label: 'Platform Container with Complete Superstructure',
  },
  {
    value: 'K0',
    label: 'Pressurized Tank Container (Liquid or Gas)',
  },
  {
    value: 'N0',
    label: 'Dry Tank Container(Pressurized or Non Pressurized)',
  },
]

/**
 *
 * @param {string} value
 * @returns {{ value: string , label: string, labelShort?: string }}
 */
export function getContainerTypeInfo(value = null) {
  value = value.toUpperCase()

  const containerType = CONTAINER_TYPES.find(i => i.value === value)

  if (!containerType) return {}

  return containerType
}

export const DATE_FORMAT_STOP_LFD_VESSEL_CUT = 'MM/dd/yy'
